import styled from 'styled-components';

export const DivAbs = styled.div(props => {
    return {
        position: 'absolute',
        top: '50px',
        right: props.direction === 'right' ? '0px' : '',
        display: 'flex',
        flexDirection: props.direction === 'right' ? 'row-reverse' : 'row',
        justifyContent: 'center',
        alignItems: 'center',
        opacity: '100',
        zIndex: '100',
        borderRadius: '5px 0px 0px 5px',
        textAlign: 'center'
    };
});

export const DivChild1 = styled.div(props => {
    return {
        border: 'white',
        cursor: 'pointer',
        width: '16px',
        height: '95px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        WebkitAlignSelf: 'start',
        MsFlexItemAlign: 'start',
        borderRadius: props.direction === 'right' ? '5px 0 0 5px' : '0 5px 5px 0',
        background: 'rgb(92,125,175)'
    };
});

export const PanelButton = styled.div(props => {
    return {
        border: 'white',
        cursor: 'pointer',
        width: '95px',
        height: '16px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        WebkitAlignSelf: 'start',
        MsFlexItemAlign: 'start',
        borderRadius: props.direction === 'right' ? '5px 0 0 5px' : '0 5px 5px 0',
        background: 'rgb(92,125,175)'
    };
});

export const DivPanel = styled.div`
    height: 700px;
    background: rgb(66, 66, 66);
    border: 1px solid rgb(64, 77, 88);
    color: rgb(255, 255, 255);
        -moz-transition: width .5s;
        -ms-transition: width .5s;
        -o-transition: width .5s;
        -webkit-transition: width .5s;
        transition: width .5s;
        width: 0;
        overflow: hidden;
`;
export const InnerDIv = styled.div`
    /* display: flex; */
    color: #fff;
    align-self: center;
    align-items: center;
    text-align: center;
    /* margin-top: 0; */
    /* margin-bottom: 0; */
    `;

export const InnerUpperDIv = styled.div`
/* display: flex; */
color: #fff;
align-self: center;
align-items: center;
text-align: center;
/* margin-top: 0; */
/* margin-bottom: 0; */
`;


export const UpperParentDiv = styled.div(({ bottom, aligns, height, ...rest }) => {
    return {
        ...rest,
        position: 'fixed',
        marginLeft: 'auto',
        marginRight: 'auto',
        zIndex: 200,
        left: 0,
        right: 0,
        height,
        top: aligns === 'top' ? 0 : null,
        bottom: bottom ? bottom : aligns === 'top' ? null : 0,
        textAlign: 'center',
        display: 'flex',
        width: 'fit-content',
        flexDirection: aligns === 'top' ? 'column' : 'column-reverse'
    };
});


export const GrowUpDown = styled.div(({ dialogColor, height }) => {
    return { height: height ? height : 0,
        overflow: 'hidden',
        width: '100vw',
        background: dialogColor ? dialogColor : 'rgba(0, 0, 0, 0.83)' };
});
